import { render, staticRenderFns } from "./modalProveedoresImportantes.vue?vue&type=template&id=48b3b688"
import script from "./modalProveedoresImportantes.vue?vue&type=script&lang=js"
export * from "./modalProveedoresImportantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports